import { faTimes, faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { theme } from 'globalStyles'
import { arrayOf, string } from 'prop-types'
import { useCallback, useState } from 'react'
import styled from 'styled-components'
import { Controls } from './Controls'
import { Slider } from './Slider'

export const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [fullScreen, setFullScreen] = useState(false)
  const goToNextItem = useCallback(
    () =>
      setCurrentIndex(currentIndex => {
        if (currentIndex >= images.length - 1) return currentIndex
        return currentIndex + 1
      }),
    [images]
  )
  const goToPrevItem = useCallback(
    () =>
      setCurrentIndex(currentIndex => {
        if (currentIndex <= 0) return currentIndex
        return currentIndex - 1
      }),
    []
  )

  return (
    <Wrap>
      <Controls
        images={images}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        goToPrevItem={goToPrevItem}
        goToNextItem={goToNextItem}
      />
      <Slider images={images} currentIndex={currentIndex} fullScreen={fullScreen} setFullScreen={setFullScreen} />
      {fullScreen && <CloseFullScreenIcon icon={faTimes} onClick={() => setFullScreen(false)} />}

      <ArrowWrap left fullScreen={fullScreen}>
        <ControlIcon icon={faChevronLeft} onClick={goToPrevItem} disabled={currentIndex === 0} />
      </ArrowWrap>
      <ArrowWrap right fullScreen={fullScreen}>
        <ControlIcon icon={faChevronRight} onClick={goToNextItem} disabled={currentIndex === images.length - 1} />
      </ArrowWrap>
    </Wrap>
  )
}

ImageSlider.propTypes = {
  images: arrayOf(string).isRequired,
}

export const Wrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  position: relative;
  padding: 0 2rem;
`

const CloseFullScreenIcon = styled(FontAwesomeIcon)`
  color: var(--color-primary);
  font-size: 2rem;
  position: fixed;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  z-index: 101;
`

const ArrowWrap = styled.div`
  position: ${({ fullScreen }) => (fullScreen ? 'fixed' : 'absolute')};
  top: 0;
  ${({ left }) => left && `left: 1rem;`}
  ${({ right }) => right && `right: 1rem;`}
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 100%;
  z-index: 100;
  display: flex;

  ${theme.breakpoints.tablet} {
    display: ${({ fullScreen }) => (fullScreen ? 'flex' : 'none')};
  }
`
const ControlIcon = styled(FontAwesomeIcon)`
  color: var(--color-primary);
  font-size: 2rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`
